export default "__VITE_ASSET__9dX6CSAliAPh6CCt9DEajA__"